export const types = {
  SET_AUTH_STATE: "SET_AUTH_STATE",
  INIT_AUTH_STATE: "INIT_AUTH_STATE",
  SET_SSO_STATE: "SET_SSO_STATE",
  INIT_SSO_STATE: "INIT_SSO_STATE",
};

const initialAuthState = {
  authToken: "",
  isLoggedIn: false,
  user: {},
};

export function auth_reducer(state = initialAuthState, action) {
  switch (action.type) {
    case types.SET_AUTH_STATE:
      return { ...state, ...action.payload };
    case types.INIT_AUTH_STATE:
      return { ...initialAuthState };
    default:
      return state;
  }
}

const initialSsoState = {};

export function sso_reducer(state = initialSsoState, action) {
  switch (action.type) {
    case types.SET_SSO_STATE:
      return { ...state, ...action.payload };
    case types.INIT_SSO_STATE:
      return { ...initialSsoState };
    default:
      return state;
  }
}
